import { trimStartSlashes } from "@ryde/shared";

/** The part of the route to carry over when redirecting to the company-scoped URL: the entity id and/or the sub-path. */
export const buildCompanyRedirectPathSuffix = ({
  routeId,
  subPath,
}: {
  routeId?: string;
  subPath?: string;
}): string => {
  return [routeId, subPath]
    .map(segment => segment?.trim())
    .filter((segment): segment is string => Boolean(segment))
    .map(segment => `/${trimStartSlashes(segment)}`)
    .join("");
};
